import { render } from "./BranchView.vue?vue&type=template&id=2a38d264"
import script from "./BranchView.vue?vue&type=script&lang=js"
export * from "./BranchView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__